import { defineMessages } from 'react-intl'

export default defineMessages({
  Pay: {
    id: 'components.PaymentMethods.CardPay.Pay',
    defaultMessage: 'Pay',
    description: '请修改',
  },
  Useanewcard: {
    id: 'components.PaymentMethods.CardPay.Useanewcard',
    defaultMessage: 'Enter card details',
    description: '请修改',
  },
  Maximum3toadd: {
    id: 'components.PaymentMethods.CardPay.Maximum3toadd',
    defaultMessage: 'Maximum 3 cards can be added',
    description: '请修改',
  },
  Notavailable: {
    id: 'components.PaymentMethods.CardPay.Notavailable',
    defaultMessage: 'Not available',
    description: '请修改',
  },
  Cancel: {
    id: 'components.PaymentMethods.CardPay.Cancel',
    defaultMessage: 'Cancel',
    description: '请修改',
  },
  ConfirmDelete: {
    id: 'components.PaymentMethods.CardPay.ConfirmDelete',
    defaultMessage: 'Confirm Delete',
    description: '请修改',
  },
  Wehavenotfoundanycardsofyours: {
    id: 'components.PaymentMethods.CardPay.Wehavenotfoundanycardsofyours',
    defaultMessage: 'We have not found any saved cards',
    description: '请修改',
  },
})
